import styled from 'styled-components';
import { color } from '~/assets/styles/colors';
import { Button } from 'reactstrap';

export const FilterAndDown = styled.div`
	display: flex;
	justify-content: right;
	margin-bottom: 10px;
`;

export const TextClick = styled.div`
	color: ${color.blue};
	cursor: pointer;
	margin-right: 20px;
	font-size: 16px;
`;

export const DivMontante = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
`;

export const ImgMontante = styled.img`
	filter: brightness(0);
`;

export const TextMontante = styled.div``;

export const ButtonStyle = styled(Button)`
	//float: right;

	//width: 100%;
	background-color: ${color.yellow};
	border-radius: 15px;
	color: ${color.black};
	border-color: transparent;
`;
